import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import './index.css';
// import "../public/style.css";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);